<template>
  <div class="personalTodo">
    <vx-card
      :class="bgColor"
      class="mb-3"
      style="width: 100%; padding: 0px"
      @click.stop="onClick"
    >
      <div class="vs-row" style="display: flex">
        <div class="vs-col lg:w-1/2">
          <feather-icon
            :icon="icon"
            class="p-2 mb-2 inline-flex rounded-full text-white shadow"
            :class="iconColor"
            svgClasses="h-4 w-4"
          ></feather-icon>
          <h6 class="text-white">{{ name }}</h6>
        </div>
        <div
          class="vs-col lg:w-1/2"
          style="margin-left: auto; text-align: right"
        >
          <h6 class="text-white">{{ todosCount }}</h6>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
export default {
  name: "TodoFilterCard",
  components: {},

  props: ["filter", "name", "color", "icon"],
  data() {
    return { test: "HomeIcon" };
  },
  computed: {
    ...mapGetters({
      currentFilter: "personalTodos/filter",
    }),
    todosCount() {
      return this.$store.getters["personalTodos/todosByFilterType"](this.filter)
        .length;
    },
    isSelected() {
      return this.currentFilter === this.filter;
    },
    bgColor() {
      return this.isSelected ? `todo-bg-${this.color}` : "todo-bg-dark";
    },
    iconColor() {
      return this.isSelected ? "todo-bg-dark" : `todo-bg-${this.color}`;
    },
  },
  mounted() {},

  beforeDestroy: function () {},
  methods: {
    async onClick() {
      await this.$store.dispatch("personalTodos/changeFilter", this.filter);
    },
  },
};
</script>

<style lang="scss">
.personalTodo > .vx-card .vx-card__collapsible-content .vx-card__body {
  padding: 10px;
  border-radius: 5px;
  cursor: pointer;
}
.todo-bg-blue {
  background-color: #0a84ff;
}
.todo-bg-red {
  background-color: #ff443a;
}
.todo-bg-yellow {
  background-color: #ff9f0a;
}
.todo-bg-primary {
  background-color: #877cf2;
}
.todo-bg-dark {
  background-color: #a4acb18a;
}
</style>